import React, { useState } from 'react';

const WhatsAppFloatButton = ({ phoneNumber, callNumber }) => {
  const [hoveredWhatsApp, setHoveredWhatsApp] = useState(false);
  const [hoveredPhone, setHoveredPhone] = useState(false);

  const handleWhatsAppClick = () => {
    const url = `https://wa.me/${phoneNumber}`;
    window.open(url, '_blank');
  };

  const handlePhoneClick = () => {
    callNumber="919610415221"
    const url = `tel:${callNumber}`;
    window.location.href = url;
  };

  return (
    <div style={{ position: 'fixed', bottom: '20px', left: '20px', zIndex: 1000 }}>
      {/* Phone Button */}
      <div
        onMouseEnter={() => setHoveredPhone(true)}
        onMouseLeave={() => setHoveredPhone(false)}
        onClick={handlePhoneClick}
        style={{
          display: 'flex',
          alignItems: 'center',
          cursor: 'pointer',
          marginBottom: '10px', // Space between phone and WhatsApp buttons
        }}
      >
        <div
          style={{
            backgroundColor: '#007bff',
            color: 'white',
            borderRadius: '50%',
            width: '60px',
            height: '60px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            boxShadow: '0 4px 8px rgba(0,0,0,0.3)',
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            fill="white"
            viewBox="0 0 24 24"
          >
            <path d="M6.62 10.79a15.053 15.053 0 006.59 6.59l2.2-2.2a1.003 1.003 0 011.11-.21c1.2.48 2.5.74 3.83.74.55 0 1 .45 1 1v3.5c0 .55-.45 1-1 1C10.29 22 2 13.71 2 3.5 2 2.95 2.45 2.5 3 2.5H6.5c.55 0 1 .45 1 1 0 1.33.26 2.63.74 3.83.13.27.07.59-.21 1.11l-2.2 2.2z" />
          </svg>
        </div>
        <div
          style={{
            backgroundColor: '#fff',
            color: '#333',
            padding: '10px 15px',
            borderRadius: '20px',
            marginLeft: '10px',
            fontSize: '14px',
            fontWeight: '500',
            boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
            opacity: hoveredPhone ? 1 : 0,
            transform: hoveredPhone ? 'translateX(0)' : 'translateX(-10px)',
            transition: 'opacity 0.3s ease, transform 0.3s ease',
            whiteSpace: 'nowrap',
          }}
        >
          Call Us Now
        </div>
      </div>

      {/* WhatsApp Button */}
      <div
        onMouseEnter={() => setHoveredWhatsApp(true)}
        onMouseLeave={() => setHoveredWhatsApp(false)}
        onClick={handleWhatsAppClick}
        style={{
          display: 'flex',
          alignItems: 'center',
          cursor: 'pointer',
        }}
      >
        <div
          style={{
            backgroundColor: '#25D366',
            color: 'white',
            borderRadius: '50%',
            width: '60px',
            height: '60px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            boxShadow: '0 4px 8px rgba(0,0,0,0.3)',
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            fill="white"
            viewBox="0 0 24 24"
          >
            <path d="M16.66 13.127c-.265-.133-1.56-.77-1.8-.857-.24-.088-.41-.133-.58.132s-.665.857-.817 1.033c-.15.176-.3.198-.565.066-.265-.133-1.118-.412-2.13-1.313-.787-.7-1.32-1.566-1.475-1.83-.153-.264-.017-.407.116-.54.118-.117.264-.3.396-.45.133-.15.176-.264.265-.44.088-.176.044-.33-.022-.463-.066-.132-.58-1.4-.793-1.91-.21-.51-.42-.442-.58-.45h-.497c-.15 0-.396.066-.6.33s-.79.772-.79 1.88c0 1.107.81 2.18.923 2.334.117.15 1.6 2.446 3.88 3.43 2.28.982 2.28.656 2.69.616.41-.044 1.325-.54 1.51-1.06.19-.523.19-.97.132-1.06-.056-.088-.22-.132-.485-.264zM12.01 2.002c-5.514 0-9.99 4.475-9.99 9.99 0 1.76.462 3.49 1.34 5.01l-1.428 5.21 5.34-1.4c1.45.794 3.08 1.215 4.737 1.215 5.514 0 9.99-4.475 9.99-9.99s-4.476-9.99-9.99-9.99zm0 18.32c-1.46 0-2.888-.39-4.13-1.13l-.296-.174-3.168.828.847-3.103-.19-.318c-.805-1.346-1.23-2.888-1.23-4.422 0-4.687 3.812-8.5 8.5-8.5s8.5 3.813 8.5 8.5-3.813 8.5-8.5 8.5z" />
          </svg>
        </div>
        <div
          style={{
            backgroundColor: '#fff',
            color: '#333',
            padding: '10px 15px',
            borderRadius: '20px',
            marginLeft: '10px',
            fontSize: '14px',
            fontWeight: '500',
            boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
            opacity: hoveredWhatsApp ? 1 : 0,
            transform: hoveredWhatsApp ? 'translateX(0)' : 'translateX(-10px)',
            transition: 'opacity 0.3s ease, transform 0.3s ease',
            whiteSpace: 'nowrap',
          }}
        >
          Chat with us on WhatsApp
        </div>
      </div>
    </div>
  );
};

export default WhatsAppFloatButton;